import { diContainer } from '../../libs/container';

interface ErrorState {
    isError: boolean;
    errorMessage?: string;
    errorName?: string;
}

export class CacheStateHandler {
    private requestStateMap = new Map<string, any>();
    private pendingState = new Map<string, boolean>();
    private listeners = new Map<string, Array<(data?: any) => void>>();

    public subscribe(key: string, listener: (data?: ErrorState) => void) {
        if (!this.listeners.has(key)) {
            this.listeners.set(key, []);
        }
        this.listeners.get(key)?.push(listener);
    }

    public notifyListeners(key: string, data?: ErrorState) {
        if (this.listeners.has(key)) {
            const listeners = this.listeners.get(key);
            listeners?.forEach(listener => listener(data));
            this.listeners.delete(key);
        }
    }

    public isInPendingState(key: string): boolean {
        return this.pendingState.get(key) || false;
    }

    public setupAsPending(key: string) {
        this.pendingState.set(key, true);
    }

    public setRequestState(key: string, requestState: any, invalidCacheTime: number) {
        this.requestStateMap.set(key, requestState);
        this.notifyListeners(key);
        this.pendingState.delete(key);
        if (invalidCacheTime) {
            setTimeout(() => {
                this.requestStateMap.delete(key);
                this.pendingState.delete(key);
            }, invalidCacheTime);
        }
    }

    public getRequestState(key: string) {
        return this.requestStateMap.get(key);
    }

    public clearPendingState(key: string) {
        this.pendingState.delete(key);
    }

    public clearCache(key: string) {
        this.requestStateMap.delete(key);
        this.pendingState.delete(key);
    }
}

diContainer.bindAsConstant(CacheStateHandler, new CacheStateHandler());
